import { useRefetchQuery } from "libs/reactQuery";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect } from "react";

import { Order } from "../orders.types";

export const useOrdersAndReturnsListRealTimeUpdate = () => {
  const { orderSocket } = useContext(SocketsContext);

  const refetchOrders = useRefetchQuery(["order"]);

  useEffect(() => {
    if (orderSocket.socket) {
      orderSocket.socket.emit("subscribe-to-order-change");
    }

    orderSocket.socket?.on(
      "order-change",
      (_data: { isNew: boolean; order: Order }) => {
        refetchOrders();
      }
    );

    return () => {
      orderSocket.socket?.off("order-change");

      if (orderSocket.socket) {
        orderSocket.socket.emit("unsubscribe-from-order-change");
      }
    };
  }, [orderSocket.socket]);
};
